export function formatPercent(value: number, total: number): string {
  return `${(value / total).toLocaleString('en', {
    style: 'percent',
    maximumSignificantDigits: 2,
  })}`
}
